import apiService from "../api/service"
// import adapter from "./adapter"

const service = {
  async get(id){
    return await apiService.getById('organizations', id)
  },
  async getStatistics(id){
    return await apiService.getFromPathReport(`a1/organizations/${id}/programs/`)
  },
}

export default service
